<!--component html goes here -->
<!-- Hero Start -->
<app-header></app-header>

<section *ngIf="mainForm" class="bg-half-170 d-table w-100" id="home" style="background: url('assets/images/travel/bg.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <!-- <div class="col-lg-12 text-center">
          <div class="pages-heading">
            <h3 class="title text-white title-dark mb-0"> {{modelObject.titleEn}} </h3>
          </div>
        </div> -->
        <!--end col-->
  
      <div class="position-breadcrumb">
        <nav aria-label="breadcrumb" class="d-inline-block">
          <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a routerLink="/country-events/{{modelObject.countryId}}">Events in {{modelObject.countryNameEn}}</a></li>
                  <li class="breadcrumb-item"><a>Event Details</a></li>
          </ul>
        </nav>
      </div>
    </div> <!--end container-->
  </section><!--end section-->
  
  <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!-- Hero End -->
  <section class="section">
    <div class="container">
          <div class="row">
            <div class="col-md-8">
              <ul class="list-unstyled d-flex">
                <ngb-carousel style="text-align: center;">
                  <ng-template ngbSlide *ngFor="let item of files">
                     <div class="picsum-img-wrapper" >
                         <img src="{{item.imageURL}}" class="img-fluid work-image" alt="" />
                     </div>
                  </ng-template>
                </ngb-carousel>
              </ul >
              <h5 class="mt-4"> {{modelObject.titleEn}}</h5>
              <p class="text-muted">{{modelObject.descriptionEn}}.</p>
              <div class="table-responsive">
              <table class="table table-hover table-middle th-fw-light mb-0">
                <thead class="shadow-none p-3 mb-5 bg-light rounded">
                    <tr>
                        <th>Country</th>
                        <th>City</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{modelObject.countryNameEn}}</td>
                        <td>{{modelObject.cityNameEn}}</td>
                    </tr>
                </tbody>
              </table>
              </div>
              <!--end form-->
            </div>
            <div class="col-lg-4 ">
              <iframe _ngcontent-owr-c170="" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" allowfullscreen="" class="rounded" style="border: 0;"></iframe>
              <div class="card border-0 rounded shadow">
                <ngx-simplebar style="max-height: 360px;">
                  <h5 class="mt-3">Comments :</h5>
                  
                  <ul class="media-list list-unstyled mb-0">
                    <li class="mt-3" *ngFor="let item of EvaluationList">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                          <a class="pe-3" href="javascript:void(0)">
                            <img src="assets/images/client/01.jpg" class="img-fluid avatar avatar-md-sm rounded-circle shadow"
                              alt="img">
                          </a>
                          
                          <div class="flex-1 commentor-detail">
                            <h6 class="mb-0"><a href="javascript:void(0)" class="text-dark media-heading">Lorenzo Peterson</a>
                            </h6>
                            <small class="text-muted">{{item.date|date:'dd/MM/yyyy hh:MM'}}</small>
                          </div>
                        </div>
                        <a >
                        <ngb-rating [max]="5" [(rate)]="item.numberOfStars" [readonly]="true" style="font-size: 30px;"> </ngb-rating>
                      </a>
                      </div>
                      <div class="overflow-hidden flex-1 ms-2">
                        <div class="d-flex justify-content-between text-muted p-3 bg-light rounded">
                            <p  >{{item.comment}}
                            </p>
                            <small class="text-muted"><a  href="javascript:void(0)" data-bs-toggle="modal" (click)="setCommentId(item.id)" data-bs-target="#LoginForm" class="btn btn-primary ms-md-2" style="width: 77px; height: 30px; font-size: 10px;"> Report</a>
                            </small>
                            <!-- <small class="text-muted"><a  href="javascript:void(0)" data-bs-toggle="modal" (click)="setCommentId(item.id)" data-bs-target="#LoginForm" class="btn btn-primary ms-md-2"> Report</a>
                            </small> -->
                        </div>
                    </div>
                    </li>
                  </ul>
                </ngx-simplebar>
                <h5 class="mt-3">Leave A Comment :</h5>
                <form class="mt-3">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="form-label">Your Comment</label>
                        <div class="form-icon position-relative">
                          <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                          <textarea id="message" placeholder="Your Comment" rows="5" name="message"
                            class="form-control ps-5" required="" [(ngModel)]="myComment"></textarea>
                        </div>
                        <div >
                          <ngb-rating  [max]="5" [(rate)]="myStars" [readonly]="false"></ngb-rating>
                        </div>
                        <div>
                          
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="send d-grid">
                        <button type="submit" class="btn btn-primary" (click)="SaveEvaluation()">Comment</button>
                      </div>
                    </div>
                    <!--end col-->
                  </div>
                  <!--end row-->
                </form>
             </div>
            </div>
          </div>
    </div>
  </section>
  <div *ngIf="ReportForm" class="modal fade" id="LoginForm" tabindex="-1" aria-labelledby="LoginForm-title" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
            <div class="modal-header border-bottom">
                <h5 class="modal-title" id="LoginForm-title">Send Report</h5>
                <button type="button" class="btn btn-icon btn-close" data-bs-dismiss="modal" id="close-modal"><i class="uil uil-times fs-4 text-dark"></i></button>
            </div>
            <div class="modal-body">
              <h3 class="modal-title" id="LoginForm-title">Your Report</h3>
                <div class="bg-white p-3 rounded box-shadow">
                  <div class="row">
                    <textarea class="text-muted mb-0" rows="6" [(ngModel)]="message"> </textarea>                                                        
                  </div>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closebutton id="closebutton">Close</button>
                <button type="button" class="btn btn-primary" (click)="SendReport()">Send</button>
            </div>
        </div>
    </div>
</div>
  <!-- Back to top -->
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
  <!-- Back to top -->